const config = {
    backendUrl: import.meta.env.REACT_APP_BackendUrl,
    osrmServiceUrl: import.meta.env.REACT_APP_OSRM_SERVICE_URL,
};

export default config;
